<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <search v-on:download="onDownload" v-on:searching="onSearch"></search>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-checkbox
                hide-details
                label="Enviar correos"
                primary
                v-model="form.sendEmails"
              ></v-checkbox>
              <v-btn @click="handleApproved()" color="success">aprobadas</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-toolbar card color="white">
              <b>Tienes {{ form.invoices.length }} facturas seleccionadas.</b>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">
                    <v-checkbox
                      hide-details
                      primary
                      v-model="props.selected"
                    ></v-checkbox>
                  </td>
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    {{ dateFormat(props.item.receivedDate) }}
                  </td>
                  <td class="text-sm-left">
                    <v-edit-dialog
                      :return-value.sync="props.item.fdcontrolNumber"
                      lazy
                      @open="open"
                      @save="handleControlNumber(props.item)"
                    >
                      <v-text-field
                        readonly
                        v-model="props.item.fdcontrolNumber"
                      ></v-text-field>
                      <template v-slot:input>
                        <v-text-field
                          v-model="props.item.fdcontrolNumber"
                          single-line
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleDetails(props.item)" color="info" text
                      >detalles</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleReject(props.item)" color="error" text
                      >rechazo</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    {{ props.item.totalInTransit }}
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              @input="asyncPagination"
              :total-visible="7"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :key="detail.key"
        v-on:close-detail="detail.show = false"
        :item="detail.data"
      ></compose>
    </v-dialog>

    <v-dialog max-width="500" v-if="rejected.data" v-model="rejected.show">
      <rejected
        :key="rejected.key"
        v-on:save-rejected="handleSaved"
        v-on:close-rejected="rejected.show = false"
        :item="rejected.data"
      ></rejected>
    </v-dialog>

    <v-dialog max-width="500" v-if="attachment.data" v-model="attachment.show">
      <attachment
        :key="attachment.key"
        v-on:close-attach="attachment.show = false"
        :item="attachment.data"
      ></attachment>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar v-model="snack.show" :timeout="5000" :color="snack.color">
      {{ snack.message }}
      <v-btn flat @click="snack.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import compose from './../dialog/DialogDetails'
import rejected from './../dialog/DialogRejected'
import loading from './../dialog/DialogLoading'
import attachment from './../dialog/DialogAttachment'
import message from './../dialog/Message'
import SessionHelper from '@/helpers/SessionHelper'
import search from './Search.vue'
import { dateFormat } from '@/helpers/TransitHelper'

export default {
  components: {
    compose,
    rejected,
    loading,
    attachment,
    message,
    search,
  },
  data() {
    return {
      snack: {
        show: false,
        color: 'info',
        message: '',
      },
      dialog: {
        show: null,
        key: 0,
      },
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      attachment: {
        show: null,
        data: null,
        key: 0,
      },
      detail: {
        show: null,
        data: null,
        key: 0,
      },
      rejected: {
        show: null,
        data: null,
        key: 0,
      },
      form: {
        invoices: [],
        sendEmails: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: '',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Facturas',
            sortable: false,
            value: 'invoiceNumber',
            align: 'left',
          },
          {
            text: 'Ingreso',
            sortable: false,
            value: 'admissionDate',
            align: 'left',
          },
          {
            text: 'Control F&D',
            sortable: false,
            value: 'fdcontrolNumber',
            align: 'left',
          },
          {
            text: 'Detalles',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Rechazo',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Dias en F&D',
            sortable: false,
            align: 'center',
          },
        ],
      },
    }
  },
  watch: {
    'complex.selected': function(val) {
      if (val) {
        this.form.invoices = []
        Object.keys(val).map(objectKey => {
          this.form.invoices.push(val[objectKey].id)
        })
      }
    },
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    ...mapState({
      invoices: state => state.transit.fd,
    }),
  },
  methods: {
    dateFormat,
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'fd',
        sortBy: 'admissionDate',
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store.dispatch('transit/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            data: { ...row, products: items ? items : null },
            show: true,
            key: this.detail.key + 1,
          }
        })
    },

    handleApproved() {
      if (this.form.invoices.length > 0) {
        this.loading = true
        this.$store.dispatch('transit/approve', this.form).then(() => {
          this.asyncPagination().then(() => {
            this.dialog = {
              message: 'La factura seleccionadas fueron aprobadas',
              color: 'primary',
              show: true,
              key: this.dialog.key + 1,
            }
          })
        })
      }
    },
    handleReject(row) {
      this.rejected = {
        data: row,
        show: true,
        key: this.rejected.key + 1,
      }
    },
    handleAttachment(row) {
      this.attachment = {
        data: row,
        show: true,
        key: this.attachment.key + 1,
      }
    },
    closeAttachment() {
      this.attachment.show = false
    },
    handleSaved() {
      this.rejected.show = false
      this.loading = true

      this.asyncPagination().then(() => {
        this.dialog = {
          message: 'La factura fue rechazada',
          color: 'primary',
          show: true,
          key: this.dialog.key + 1,
        }
      })
    },
    handleControlNumber(row) {
      this.$store
        .dispatch('transit/controlNumber', {
          controlNumber: row.fdcontrolNumber,
          invoicesID: row.id,
        })
        .then(() => {
          this.snack = {
            show: true,
            color: 'success',
            message: 'El numero de control fue actualizado.',
          }
        })
    },
    open() {
      this.snack = {
        show: true,
        color: 'orange accent-3',
        message: 'Presione ENTER para salvar los datos.',
      }
    },
    onSearch(params) {
      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'fd',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>
<style scope="css">
.v-messages__message {
  text-align: right !important;
  font-size: 11px;
}
</style>
